import * as React from 'react';

export interface SelfSettledSNTIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * SelfSettledSNTIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Self-Settled Special Needs Trust. Teal shield with 'SNT' white reverse-out.
 */
const SelfSettledSNTIcon: React.FunctionComponent<SelfSettledSNTIconProps> = ({
  className,
  size = 40,
  title = 'Self-Settled Special Needs Trust',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M24 4 L40 8 L40 24 Q40 36 24 44 Q8 36 8 24 L8 8 Z" fill="#0f7e88"/>
      <path d="M24 8 L37 11.5 L37 24 Q37 33 24 40 Q11 33 11 24 L11 11.5 Z" fill="none" stroke="#08484e" strokeWidth="0.6"/>
      <text x="24" y="28" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="11" fontWeight="900" fill="#FFFFFF" letterSpacing="0.6">SNT</text>
  </svg>
);

export default SelfSettledSNTIcon;
